module.exports = __webpack_public_path__ + "assets/Office365.b3d8aa77.svg";